module.exports = __webpack_public_path__ + "static/media/placeholder-image.9375cb3a.png";